module.exports = ".LedContainer{\r\n    height: 200px;\r\n    width: 100%;\r\n    padding-right: 10px;\r\n}\r\n\r\n.ColorContainer{\r\n    width: 100%;\r\n    height: 80%;\r\n    background-color: white;\r\n}\r\n\r\n.ColorContainer .ColorBox{\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.SliderContainer{\r\n    width: 100%;\r\n    height: 20%;\r\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/Components/LedFaded/LedFaded.component.css
 ** module id = 42
 ** module chunks = 0
 **/